// extracted by mini-css-extract-plugin
export var alternate = "_g-h";
export var black = "_g-3";
export var blue = "_g-d";
export var blueLight = "_g-c";
export var brand = "_g-7";
export var error = "_g-9";
export var gray = "_g-6";
export var grayBlue = "_g-b";
export var iconWrapper = "_g-4";
export var indigo = "_g-e";
export var orange = "_g-g";
export var pink = "_g-f";
export var primary = "_g-0";
export var purple = "_g-8";
export var success = "_g-5";
export var warning = "_g-a";
export var white = "_g-1";
export var whiteSuccess = "_g-2";